import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { IdentificationVisitDetailsPage } from 'features/identificationVisits'
import { eventQueryOptionsV4 } from 'hooks/api/event'
import { canViewAnalyticsPermission } from 'hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/events/$requestId/')({
  component: IdentificationVisitDetailsPage,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Visit Details'),
      },
    ],
  }),
  beforeLoad: async (ctx) => {
    await protectWithWorkspacePermissions(canViewAnalyticsPermission)(ctx)

    return {
      eventQueryOptionsV4: eventQueryOptionsV4(
        ctx.context.buildRequest,
        ctx.params.subscriptionId,
        ctx.params.requestId,
        true
      ),
    }
  },
  loader: ({ context: { eventQueryOptionsV4: prefetchOptions, queryClient } }) => {
    queryClient.prefetchQuery(prefetchOptions)
  },
})
